// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMSkeleton.tsx — PropelMapper loading placeholder.
//
// A token-driven shimmer block for content that hasn't loaded yet. One flexible
// component with three shapes — rect (default), text (multi-line), circle — that
// compose into any skeleton (card, table row, avatar + lines). The sheen adapts
// to light/dark and is disabled under prefers-reduced-motion.
//
// Accessibility: the block is decorative (aria-hidden). Put aria-busy="true" on
// the region you're filling, or pass `label` to expose a polite "Loading…" status.
//
//   <PMSkeleton width={120} height={20} />
//   <PMSkeleton shape="text" lines={3} />
//   <PMSkeleton shape="circle" width={40} />

const PMSKEL_CSS = `
.pmskel{display:block;position:relative;overflow:hidden;background:var(--pm-surface-variant);--pmskel-sheen:rgba(255,255,255,.6)}
.pmskel::after{content:"";position:absolute;inset:0;transform:translateX(-100%);background:linear-gradient(90deg,transparent,var(--pmskel-sheen),transparent);animation:pmskelShimmer 1.4s ease-in-out infinite}
:root[data-theme="dark"] .pmskel{--pmskel-sheen:rgba(255,255,255,.08)}
.pmskel-text{display:flex;flex-direction:column}
@keyframes pmskelShimmer{100%{transform:translateX(100%)}}
@media (prefers-reduced-motion: reduce){.pmskel::after{animation:none;display:none}}
.pmskel-sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}
`;

function pmskelEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmskel-css")) return;
  const s = document.createElement("style"); s.id = "pmskel-css"; s.textContent = PMSKEL_CSS;
  document.head.appendChild(s);
}

const pmskelDim = (v: any) => (typeof v === "number" ? v + "px" : v);

export function PMSkeleton({
  shape = "rect",
  width,
  height,
  radius,
  lines = 3,
  lineGap = 8,
  lastLineWidth = "60%",
  label,
  className = "",
  style = {},
}: any) {
  pmskelEnsureCSS();

  if (shape === "text") {
    const rows = [];
    for (let i = 0; i < lines; i++) {
      const isLast = i === lines - 1 && lines > 1;
      rows.push(
        <span
          key={i}
          className="pmskel"
          style={{
            height: pmskelDim(height != null ? height : 12),
            width: isLast ? lastLineWidth : "100%",
            borderRadius: pmskelDim(radius != null ? radius : 4),
          }}
        />
      );
    }
    return (
      <span
        className={"pmskel-text" + (className ? " " + className : "")}
        style={{ gap: pmskelDim(lineGap), ...style }}
        aria-hidden={label ? undefined : true}
        role={label ? "status" : undefined}
        aria-busy={label ? true : undefined}
      >
        {label ? <span className="pmskel-sr">{label}</span> : null}
        {rows}
      </span>
    );
  }

  const isCircle = shape === "circle";
  const w = width != null ? width : (isCircle ? 40 : "100%");
  const h = height != null ? height : (isCircle ? w : 16);
  const r = radius != null ? radius : (isCircle ? "50%" : "var(--pm-radius-m, 8px)");

  return (
    <span
      className={"pmskel" + (className ? " " + className : "")}
      style={{ width: pmskelDim(w), height: pmskelDim(h), borderRadius: pmskelDim(r), ...style }}
      aria-hidden={label ? undefined : true}
      role={label ? "status" : undefined}
      aria-busy={label ? true : undefined}
    >
      {label ? <span className="pmskel-sr">{label}</span> : null}
    </span>
  );
}
